import { useMutation } from "@apollo/client";
import {
  CREATE_PICKUP_RECEIVER,
  DELETE_PICKUP_RECEIVER,
  GET_PICKUP_RECEIVERS,
  UPDATE_ORDER_PICKUP,
  UPDATE_PICKUP_RECEIVER,
} from "graphql/pickup-receiver/mutation";

export const usePickupReceivers = () => {
  const [getPickupReceivers, { loading }] = useMutation(GET_PICKUP_RECEIVERS);

  const handleGetPickupReceivers = async (sellerID) => {
    const res = await getPickupReceivers({ variables: { sellerID } });
    return res?.data?.pickupReceiver?.list || [];
  };

  return { handleGetPickupReceivers, loading };
};

export const useCreatePickupReceiver = () => {
  const [createPickupReceiver, { loading }] = useMutation(CREATE_PICKUP_RECEIVER);

  const handleCreate = async ({ sellerID, fullName, phone }) => {
    const res = await createPickupReceiver({ variables: { sellerID, input: { fullName, phone } } });
    return res?.data?.pickupReceiver?.create;
  };

  return { handleCreate, loading };
};

export const useUpdatePickupReceiver = () => {
  const [updatePickupReceiver, { loading }] = useMutation(UPDATE_PICKUP_RECEIVER);

  const handleUpdate = async ({ id, fullName, phone }) => {
    const res = await updatePickupReceiver({ variables: { id, input: { fullName, phone } } });
    return res?.data?.pickupReceiver?.update;
  };

  return { handleUpdate, loading };
};

export const useDeletePickupReceiver = () => {
  const [deletePickupReceiver, { loading }] = useMutation(DELETE_PICKUP_RECEIVER);

  const handleDelete = async (id) => {
    await deletePickupReceiver({ variables: { id } });
  };

  return { handleDelete, loading };
};

export const useUpdateOrderPickup = () => {
  const [updateOrderPickup, { loading }] = useMutation(UPDATE_ORDER_PICKUP);

  const handleUpdateOrderPickup = async ({ orderID, warehouseID, pickupReceiverID }) => {
    const res = await updateOrderPickup({
      variables: {
        request: { orderID, warehouseID, pickupReceiverID },
      },
    });
    return res?.data?.sellerOps?.order?.update;
  };

  return { handleUpdateOrderPickup, loading };
};
